import { render, staticRenderFns } from "./CompilaQuestionarioScoredIpertensioneVeneto.vue?vue&type=template&id=6621a8c4&"
import script from "./CompilaQuestionarioScoredIpertensioneVeneto.vue?vue&type=script&lang=js&"
export * from "./CompilaQuestionarioScoredIpertensioneVeneto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports